import { render } from "./PostAnomalyComponent.vue?vue&type=template&id=2b09dc54"
import script from "./PostAnomalyComponent.vue?vue&type=script&lang=js"
export * from "./PostAnomalyComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__